import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { LocationItemComponent } from '../location-item/location-item.component';
import { LocationsService } from '../locations.service';
import { AddButtonComponent } from '../../../shared/components/add-button/add-button.component';

@Component({
  selector: 'app-location-list',
  imports: [LocationItemComponent, AddButtonComponent],
  templateUrl: './location-list.component.html',
  styleUrl: './location-list.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationListComponent {
  readonly #router = inject(Router);
  readonly #locationsService = inject(LocationsService);

  // Live: new and edited locations show up even though this page is kept alive between visits
  protected readonly locationsResource = rxResource({
    stream: () => this.#locationsService.locations$,
  });

  protected addLocation(): void {
    this.#router.navigate(['/main/locations/new']);
  }
}
